import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { API } from "@/lib/api";
import { frDate, frDateAny } from "@/lib/date";
import { ArrowLeft, CalendarClock, ExternalLink, FileText } from "lucide-react";

export default function Fiche() {
  const { cid, codeInsee } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/arretes/${cid}/communes/${codeInsee}`)
      .then((r) => setData(r.data))
      .catch(() => setError("Fiche introuvable."));
  }, [cid, codeInsee]);

  if (error) return <div data-testid="screen-fiche"><p>{error}</p><Link to="/recherche">Retour à la recherche</Link></div>;
  if (!data) return <div data-testid="screen-fiche"><p style={{ color: "var(--muted)" }}>Chargement…</p></div>;

  return (
    <div data-testid="screen-fiche">
      <Link to="/recherche" data-testid="fiche-back" style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem", fontSize: "0.9rem", textDecoration: "none" }}>
        <ArrowLeft size={16} /> Retour
      </Link>

      <h1 style={{ fontSize: "1.6rem", margin: "0.7rem 0 0.2rem" }}>
        {data.commune} <span style={{ color: "var(--muted)", fontWeight: 400 }}>· {data.departement}</span>
      </h1>

      <div className="pc-card" style={{ marginTop: "1rem", background: "var(--warn-soft)", borderColor: "#E4D8BE" }} data-testid="fiche-deadline">
        <div style={{ display: "flex", alignItems: "center", gap: "0.55rem" }}>
          <CalendarClock size={20} color="var(--warn)" />
          <div>
            <div style={{ fontSize: "0.85rem", color: "var(--muted)" }}>Date limite de déclaration à votre assureur</div>
            <div style={{ fontSize: "1.35rem", fontWeight: 700, fontFamily: "'Spectral', serif" }}>{frDate(data.date_limite)}</div>
          </div>
        </div>
        <div style={{ marginTop: "0.6rem" }}>
          <span className={`pc-badge ${data.statut_delai}`} data-testid="fiche-statut">
            {data.statut_delai === "en_cours" ? "Délai en cours" : "Délai échu"}
          </span>
        </div>
      </div>

      <dl style={{ marginTop: "1.2rem", display: "grid", gap: "0.8rem" }}>
        <div>
          <dt style={{ fontSize: "0.82rem", color: "var(--muted)" }}>Phénomène(s) et période(s)</dt>
          <dd style={{ margin: "0.2rem 0 0", display: "grid", gap: "0.25rem" }}>
            {data.phenomenes.map((p, i) => (
              <span key={i}>
                <strong style={{ fontWeight: 600 }}>{p.phenomene}</strong>
                <span style={{ color: "var(--muted)" }}> — du {frDateAny(p.date_debut)} au {frDateAny(p.date_fin)}</span>
              </span>
            ))}
          </dd>
        </div>
        <div>
          <dt style={{ fontSize: "0.82rem", color: "var(--muted)" }}>Date de publication au Journal officiel</dt>
          <dd style={{ margin: "0.2rem 0 0" }}>{frDate(data.date_publication)}</dd>
        </div>
      </dl>

      <h2 style={{ fontSize: "1.15rem", marginTop: "1.6rem" }}>Pièces à réunir</h2>
      <ul data-testid="fiche-pieces" style={{ paddingLeft: "1.1rem", margin: "0.4rem 0", display: "grid", gap: "0.35rem" }}>
        {data.pieces_a_reunir.map((p, i) => (
          <li key={i}>{p}</li>
        ))}
      </ul>

      <a
        href={data.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="fiche-legifrance"
        className="pc-btn"
        style={{ marginTop: "0.8rem", textDecoration: "none" }}
      >
        <ExternalLink size={18} /> Lire le texte officiel sur Légifrance
      </a>

      <div style={{ marginTop: "1.6rem", padding: "0.9rem 1rem", borderLeft: "3px solid var(--line)", background: "var(--surface)", borderRadius: 8 }} data-testid="fiche-mention">
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "flex-start" }}>
          <FileText size={18} color="var(--muted)" style={{ marginTop: 2 }} />
          <p style={{ margin: 0, fontSize: "0.88rem", color: "var(--muted)" }}>{data.mention_juridique}</p>
        </div>
      </div>
    </div>
  );
}
